module.exports = __webpack_public_path__ + "static/media/app-download@2x.66768c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-onboarding/app-download@2x.png
// module id = 2183
// module chunks = 70